var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "commonDialog", class: { notice: _vm.isNotice } },
    [
      _c(
        "van-dialog",
        {
          attrs: { "show-confirm-button": false },
          model: {
            value: _vm.dialogData.show,
            callback: function ($$v) {
              _vm.$set(_vm.dialogData, "show", $$v)
            },
            expression: "dialogData.show",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dialogData.title,
                  expression: "dialogData.title",
                },
              ],
              staticClass: "title",
            },
            [_vm._v(_vm._s(_vm.dialogData.title))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dialogData.imgUrl,
                  expression: "dialogData.imgUrl",
                },
              ],
              staticClass: "pic",
            },
            [_c("img", { attrs: { src: _vm.dialogData.imgUrl } })]
          ),
          _c("div", {
            staticClass: "text",
            domProps: { innerHTML: _vm._s(_vm.dialogData.text) },
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dialogData.confirmA,
                  expression: "dialogData.confirmA",
                },
              ],
              staticClass: "confirmA",
              on: { click: _vm.confirmA },
            },
            [_vm._v(_vm._s(_vm.dialogData.confirmA))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dialogData.confirmB,
                  expression: "dialogData.confirmB",
                },
              ],
              staticClass: "confirmB",
              on: { click: _vm.confirmB },
            },
            [_vm._v(_vm._s(_vm.dialogData.confirmB))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }